/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_Changes_Modal_TitleInputs */

const en_unsaved_changes_modal_title = /** @type {(inputs: Unsaved_Changes_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

const nl_unsaved_changes_modal_title = /** @type {(inputs: Unsaved_Changes_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet-opgeslagen wijzigingen`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Unsaved_Changes_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes_modal_title = /** @type {((inputs?: Unsaved_Changes_Modal_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_Changes_Modal_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_unsaved_changes_modal_title(inputs)
	return en_unsaved_changes_modal_title(inputs)
});